import { theme } from './_theme';

const v3Theme = {
  ripple: true,
  calendar: {
    root: {
      class: ['v3-calendar'],
    },
    table: {
      class: ['v3-calendar-table'],
    },
    input: {
      class: ['v3-body-regular-400-line-height-auto'],
    },
    groupContainer: {
      class: ['v3-body-regular-400-line-height-1.5'],
    },
  },
  card: {
    root: {
      style: {
        'border-radius': '4px',
        'box-shadow': 'none',
        border: '1px solid var(--v3-root-surface-border, #DFE7EF)',
      },
    },
  },
  datatable: {
    thead: {
      class: 'z-[1]',
    },
    wrapper: {
      style: {
        overflow: 'visible',
      },
    },
    bodyrow: {
      class: ['v3-datatable-body-row'],
    },
  },
  dropdown: {
    root({ state, props }) {
      return {
        class: [
          'rounded-[6px]  h-[38px] bg-[--v3-input-field-inputbg]',
          { 'opacity-50': props.disabled },
          {
            'border-[--v3-input-field-inputborder]': !state.focused,
            'border-[--v3-input-field-inputfocusbordercolor] shadow-[0px_0px_0px_2.8px_var(--brand-forestgreenwarm)] outline-none': state.focused,
          },
        ],
      };
    },
    list: {
      class: ['pt-[10.5px] pb-0 px-0'],
    },
    trigger: {
      class: ['text-[--v3-input-field-inputiconcolor]'],
    },
    input: {
      class: ['flex items-center v3-body-regular-400-line-height-auto text-[--v3-global-textsecondarycolor]'],
    },
    item({ context }) {
      return {
        class: [
          `h-[38px] rounded-none v3-body-regular-400-line-height-auto m-0 px-[17.5px] py-[10.5px]
          text-[--v3-global-textcolor] hover:bg-[--v3-theme-highlightbg]
          hover:text-[--v3-theme-highlighttextcolor]`,
          {
            'bg-[--v3-theme-highlightbg] text-[--v3-theme-highlighttextcolor]': context.selected || context.focused,
          },
        ],
      };
    },
  },
  inputtext: {
    root({ props }) {
      return {
        class: [
          `v3-body-regular-400-line-height-auto h-[38px] outline-none bordered bg-[--v3-input-field-inputbg] border-[--v3-input-field-inputborder]
          text-[--v3-global-textsecondarycolor]
          focus:shadow-[0px_0px_0px_2.8px_var(--brand-forestgreenwarm)] focus:border-[--v3-input-field-inputhoverbordercolor]`,
          {
            'border-[--v3-input-field-inputerrorbordercolor]': props.invalid,
          },
        ],
      };
    },
  },
  inputswitch: {
    root: {
      class: ['v3-inputswitch'],
    },
    slider({ context }) {
      return {
        class: {
          'v3-inputcheckbox-checked': context.checked,
        },
      };
    },
  },
  tabmenu: {
    root: {
      class: ['v3-tabmenu'],
    },
    menu: {
      class: ['bg-transparent', 'border-none'],
    },
    inkbar: {
      class: ['v3-inkbar', 'h-[3px]'],
    },
  },
  tabview: {
    root: {
      class: ['v3-tabmenu'],
    },
    nav: {
      class: ['bg-transparent', 'border-none'],
    },
    inkbar: {
      class: ['v3-inkbar', 'h-[3px]'],
    },
    panelContainer: {
      class: ['bg-transparent', 'border-none', 'p-0'],
    },
  },
  tabpanel: {
    headerAction: ({ tabpanel }) => ({
      class: [
        'border-none p-[17.5px]',
        {
          'bg-white': tabpanel.context.active,
          'bg-transparent': !tabpanel.context.active,
        },
      ],
    }),
    headerTitle: ({ tabpanel }) => ({
      class: [
        'font-bold',
        {
          'text-[--v3-tabview-tabviewheadertextactivecolor]': tabpanel.context.active,
          'text-[--v3-tabview-tabviewheadertextcolor]': !tabpanel.context.active,
        },
      ],
    }),
  },
  progressbar: {
    root: {
      class: ['v3-progressbar'],
    },
    value: {
      class: ['rounded-r-[6px]', 'v3-progressbar-value'],
    },
  },
  radiobutton: {
    box({ context }) {
      return {
        style: {
          border: context.checked ? '6px solid var(--next-denim-700, #336885)' : '2px solid var(--next-divider-on-dark, #D4D6D9)',
        },
      };
    },
    icon: 'bg-transparent',
  },
  confirmadialog: {
    root: 'rmd:w-[403px] rounded-md',
  },
  panel: {
    root: 'v3-cardshadow border-0 rounded-md',
    header: 'bg-[--v3-panel-panelcontentevenrowbg] rounded-b-md',
    content: 'px-4 py-6',
  },
  ...theme,
};

const options = {
  pt: v3Theme,
};

export default options;
